<template>
  <div class="groupbuy">
    <el-card>
      <div class="menu-box">
        <h2>雷锋e站团购管理</h2>
        <div class="box-bd">
          <el-row :gutter="20">
            <el-col :span="3">
              <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">发起团购</el-button>
            </el-col>
            <el-col :span="3">
              <el-button type="success" @click="multipleApproval">批量通过</el-button>
            </el-col>
            <el-col :span="4">
              <el-input
                placeholder="请输入搜索内容"
                v-model="getInfo.info"
                clearable
                @clear="search"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="search"
                ></el-button>
              </el-input>
            </el-col>
          </el-row>
          <!-- 表格 -->
          <el-table
            ref="multipleTable"
            @selection-change="handleChange"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            v-loading="loading"
            :row-key="getRowKeys"
          >
            <el-table-column
              type="selection"
              :reserve-selection="true"
              :selectable="selectable"
            />
            <el-table-column prop="title" label="团购标题" min-width="150">
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" min-width="150">
            </el-table-column>
            <el-table-column prop="price" label="团购价格" width="120">
              <template slot-scope="scope">
                <span style="color: #f56c6c; font-weight: bold;">￥{{ scope.row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="original_price" label="原价" width="120">
              <template slot-scope="scope">
                <span style="text-decoration: line-through; color: #999;">￥{{ scope.row.original_price }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="group_num" label="成团人数" width="100">
            </el-table-column>
            <el-table-column prop="join_num" label="已参团" width="100">
            </el-table-column>
            <el-table-column prop="start_date" label="开始时间" width="160">
              <template slot-scope="scope">
                {{ scope.row.start_date }}
              </template>
            </el-table-column>
            <el-table-column prop="end_date" label="结束时间" width="160">
              <template slot-scope="scope">
                {{ scope.row.end_date }}
              </template>
            </el-table-column>
            <el-table-column prop="status_text" label="审核状态" width="120">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === 0" type="warning">未审核</el-tag>
                <el-tag v-else-if="scope.row.status === 1" type="success">审核通过</el-tag>
                <el-tag v-else-if="scope.row.status === 2" type="danger">审核拒绝</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="360">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.status === 0"
                  size="mini"
                  type="success"
                  icon="el-icon-check"
                  @click="pass(scope.row)"
                  >通过</el-button
                >
                <el-button
                  v-if="scope.row.status === 0"
                  size="mini"
                  type="danger"
                  icon="el-icon-close"
                  @click="decline(scope.row)"
                  >拒绝</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-edit"
                  @click="openEditDialog(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  size="mini"
                  icon="el-icon-search"
                  @click="openDetail(scope.row)"
                  >详情</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="handleDelete(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @current-change="pageChange"
            @size-change="sizeChange"
            :page-sizes="[30, 60, 100]"
            :pager-count="15"
            layout="total, sizes, prev, pager, next"
            :page-size="getInfo.page_num"
            background
            :total="exp.num"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>

    <!-- 发起/编辑团购弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :before-close="handleDialogClose"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="groupBuyFormRef"
        :model="groupBuyForm"
        :rules="groupBuyRules"
        label-width="100px"
        class="groupbuy-form"
      >
        <el-form-item label="团购标题" prop="title">
          <el-input
            v-model="groupBuyForm.title"
            placeholder="请输入团购标题"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="商品名称" prop="goods_name">
          <el-input
            v-model="groupBuyForm.goods_name"
            placeholder="请输入商品名称"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="团购价格" prop="price">
          <el-input-number
            v-model="groupBuyForm.price"
            :min="0"
            :precision="2"
            :step="10"
            placeholder="请输入团购价格"
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="原价" prop="original_price">
          <el-input-number
            v-model="groupBuyForm.original_price"
            :min="0"
            :precision="2"
            :step="10"
            placeholder="请输入原价"
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="成团人数" prop="group_num">
          <el-input-number
            v-model="groupBuyForm.group_num"
            :min="1"
            :step="1"
            placeholder="请输入成团人数"
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="活动时间" prop="dateRange">
          <el-date-picker
            v-model="groupBuyForm.dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="团购描述" prop="desc">
          <el-input
            v-model="groupBuyForm.desc"
            type="textarea"
            :rows="4"
            placeholder="请输入团购描述"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="团购图片" prop="file">
          <el-upload
            action="#"
            list-type="picture-card"
            :limit="9"
            :file-list="groupBuyForm.fileList"
            :on-remove="handleUploadRemove"
            :before-upload="beforeUpload"
            :auto-upload="false"
            accept=".jpg,.png,.jpeg,.gif"
            multiple
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="el-upload__tip">可上传多张图片，支持 jpg/png/jpeg/gif，最多9张</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 详情对话框 -->
    <el-dialog
      title="团购详情"
      :before-close="handleClose"
      :visible.sync="detailDialogVisible"
      width="80%"
    >
      <el-descriptions :column="2" border>
        <el-descriptions-item label="团购标题">{{ detailInfo.title }}</el-descriptions-item>
        <el-descriptions-item label="商品名称">{{ detailInfo.goods_name }}</el-descriptions-item>
        <el-descriptions-item label="团购价格">￥{{ detailInfo.price }}</el-descriptions-item>
        <el-descriptions-item label="原价">￥{{ detailInfo.original_price }}</el-descriptions-item>
        <el-descriptions-item label="成团人数">{{ detailInfo.group_num }}</el-descriptions-item>
        <el-descriptions-item label="已参团">{{ detailInfo.join_num }}</el-descriptions-item>
        <el-descriptions-item label="开始时间">{{ detailInfo.start_date }}</el-descriptions-item>
        <el-descriptions-item label="结束时间">{{ detailInfo.end_date }}</el-descriptions-item>
        <el-descriptions-item label="审核状态">
          <el-tag v-if="detailInfo.status === 0" type="warning">未审核</el-tag>
          <el-tag v-else-if="detailInfo.status === 1" type="success">审核通过</el-tag>
          <el-tag v-else-if="detailInfo.status === 2" type="danger">审核拒绝</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="团购描述" :span="2">{{ detailInfo.desc }}</el-descriptions-item>
      </el-descriptions>

      <h3 style="margin: 20px 0 10px 0;">团购图片</h3>
      <div v-if="detailInfo.file && detailInfo.file.length > 0" style="display: flex; flex-wrap: wrap;">
        <el-image
          v-for="(file, index) in detailInfo.file"
          :key="index"
          :src="file"
          :preview-src-list="detailInfo.file"
          style="width: 150px; height: 150px; margin: 10px;"
        ></el-image>
      </div>
      <span v-else>无图片</span>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    const validatePrice = (rule, value, callback) => {
      if (this.groupBuyForm.original_price && value >= this.groupBuyForm.original_price) {
        callback(new Error('团购价格必须低于原价'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      submitLoading: false,
      exp: {
        num: 0,
      },
      getInfo: {
        info: '',
        page_code: 1,
        page_num: 15,
      },
      // 静态模拟数据
      mockData: [
        {
          id: 1,
          title: '新鲜草莓产地直供',
          goods_name: '红颜草莓 2斤装',
          price: 39.90,
          original_price: 68.00,
          group_num: 50,
          join_num: 32,
          start_date: '2026-09-01 00:00:00',
          end_date: '2026-09-10 23:59:59',
          status: 1,
          desc: '产地直供，新鲜采摘，个大味甜，限时团购优惠。',
          file: [],
        },
        {
          id: 2,
          title: '有机蔬菜礼盒',
          goods_name: '时令有机蔬菜 6种装',
          price: 49.00,
          original_price: 88.00,
          group_num: 30,
          join_num: 18,
          start_date: '2026-09-05 00:00:00',
          end_date: '2026-09-15 23:59:59',
          status: 0,
          desc: '当日采摘，无农药残留，绿色健康，配送上门。',
          file: [],
        },
        {
          id: 3,
          title: '土鸡蛋团购',
          goods_name: '散养土鸡蛋 30枚',
          price: 29.90,
          original_price: 45.00,
          group_num: 100,
          join_num: 100,
          start_date: '2026-08-20 00:00:00',
          end_date: '2026-09-05 23:59:59',
          status: 1,
          desc: '农家散养土鸡蛋，营养丰富，团购已成团。',
          file: [],
        },
        {
          id: 4,
          title: '特色腊味礼盒',
          goods_name: '农家自制腊味 1.5kg',
          price: 99.00,
          original_price: 168.00,
          group_num: 20,
          join_num: 5,
          start_date: '2026-09-08 00:00:00',
          end_date: '2026-09-20 23:59:59',
          status: 0,
          desc: '传统工艺，农家自制，年货必备，团购优惠中。',
          file: [],
        },
      ],
      tableData: [],
      checkedItem: [],
      // 发起/编辑弹窗
      dialogVisible: false,
      dialogTitle: '发起团购',
      isEdit: false,
      groupBuyForm: {
        id: '',
        title: '',
        goods_name: '',
        price: 0,
        original_price: 0,
        group_num: 10,
        dateRange: [],
        start_date: '',
        end_date: '',
        desc: '',
        file: [],
        fileList: [],
      },
      groupBuyRules: {
        title: [{ required: true, message: '请输入团购标题', trigger: 'blur' }],
        goods_name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        price: [
          { required: true, message: '请输入团购价格', trigger: 'blur' },
          { validator: validatePrice, trigger: 'blur' },
        ],
        original_price: [{ required: true, message: '请输入原价', trigger: 'blur' }],
        group_num: [{ required: true, message: '请输入成团人数', trigger: 'blur' }],
        dateRange: [{ required: true, message: '请选择活动时间', trigger: 'change' }],
        desc: [{ required: true, message: '请输入团购描述', trigger: 'blur' }],
      },
      // 详情弹窗
      detailDialogVisible: false,
      detailInfo: {},
    }
  },
  methods: {
    getRowKeys(row) {
      return row.id
    },
    sizeChange(value) {
      this.getInfo.page_num = value
      this.fetchList()
    },
    pageChange(value) {
      this.getInfo.page_code = value
      this.fetchList()
    },
    search() {
      this.getInfo.page_code = 1
      this.fetchList()
    },
    handleChange(val) {
      this.checkedItem = val
    },
    selectable(row) {
      return row.status === 0
    },
    // ========== 列表(纯静态) ==========
    fetchList() {
      this.loading = true
      setTimeout(() => {
        let list = this.mockData
        // 模糊搜索(标题、商品名)
        if (this.getInfo.info) {
          const kw = this.getInfo.info.toLowerCase()
          list = list.filter(item =>
            (item.title || '').toLowerCase().includes(kw) ||
            (item.goods_name || '').toLowerCase().includes(kw)
          )
        }
        this.tableData = list
        this.exp.num = list.length
        this.loading = false
      }, 200)
    },
    // ========== 发起团购(纯前端) ==========
    resetGroupBuyForm() {
      this.groupBuyForm = {
        id: '',
        title: '',
        goods_name: '',
        price: 0,
        original_price: 0,
        group_num: 10,
        dateRange: [],
        start_date: '',
        end_date: '',
        desc: '',
        file: [],
        fileList: [],
      }
      if (this.$refs.groupBuyFormRef) {
        this.$refs.groupBuyFormRef.clearValidate()
      }
    },
    openAddDialog() {
      this.isEdit = false
      this.dialogTitle = '发起团购'
      this.resetGroupBuyForm()
      this.dialogVisible = true
    },
    openEditDialog(row) {
      this.isEdit = true
      this.dialogTitle = '编辑团购'
      this.resetGroupBuyForm()
      this.groupBuyForm.id = row.id
      this.groupBuyForm.title = row.title
      this.groupBuyForm.goods_name = row.goods_name
      this.groupBuyForm.price = row.price
      this.groupBuyForm.original_price = row.original_price
      this.groupBuyForm.group_num = row.group_num
      this.groupBuyForm.desc = row.desc
      this.groupBuyForm.start_date = row.start_date
      this.groupBuyForm.end_date = row.end_date
      if (row.start_date && row.end_date) {
        this.groupBuyForm.dateRange = [row.start_date, row.end_date]
      }
      this.groupBuyForm.file = row.file || []
      this.groupBuyForm.fileList = (row.file || []).map((url, index) => ({
        name: 'image_' + index,
        url: url,
      }))
      this.dialogVisible = true
    },
    handleDialogClose() {
      this.$refs.groupBuyFormRef.resetFields()
      this.dialogVisible = false
      this.resetGroupBuyForm()
    },
    handleUploadRemove(file, fileList) {
      const url = file.url
      const index = this.groupBuyForm.file.indexOf(url)
      if (index > -1) {
        this.groupBuyForm.file.splice(index, 1)
      }
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!')
      }
      return isLt5M
    },
    handleSubmit() {
      this.$refs.groupBuyFormRef.validate(valid => {
        if (!valid) return
        if (this.groupBuyForm.price >= this.groupBuyForm.original_price) {
          this.$message.warning('团购价格必须低于原价')
          return
        }
        const [start_date, end_date] = this.groupBuyForm.dateRange || []
        if (this.isEdit) {
          // 编辑:更新 mockData
          const idx = this.mockData.findIndex(item => item.id === this.groupBuyForm.id)
          if (idx > -1) {
            this.mockData[idx].title = this.groupBuyForm.title
            this.mockData[idx].goods_name = this.groupBuyForm.goods_name
            this.mockData[idx].price = this.groupBuyForm.price
            this.mockData[idx].original_price = this.groupBuyForm.original_price
            this.mockData[idx].group_num = this.groupBuyForm.group_num
            this.mockData[idx].start_date = start_date
            this.mockData[idx].end_date = end_date
            this.mockData[idx].desc = this.groupBuyForm.desc
            this.mockData[idx].file = this.groupBuyForm.file
          }
          this.$message.success('编辑成功')
        } else {
          // 新增:插入 mockData
          const newId = this.mockData.length > 0 ? Math.max(...this.mockData.map(i => i.id)) + 1 : 1
          this.mockData.unshift({
            id: newId,
            title: this.groupBuyForm.title,
            goods_name: this.groupBuyForm.goods_name,
            price: this.groupBuyForm.price,
            original_price: this.groupBuyForm.original_price,
            group_num: this.groupBuyForm.group_num,
            join_num: 0,
            start_date: start_date,
            end_date: end_date,
            status: 0,
            desc: this.groupBuyForm.desc,
            file: this.groupBuyForm.file,
          })
          this.$message.success('发起成功')
        }
        this.dialogVisible = false
        this.fetchList()
      })
    },
    // ========== 审核(纯前端) ==========
    multipleApproval() {
      if (this.checkedItem.length === 0) {
        this.$message.warning('请选择需要通过的团购！')
        return
      }
      this.$confirm('确认批量通过团购?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      })
        .then(() => {
          this.checkedItem.forEach(item => {
            const idx = this.mockData.findIndex(d => d.id === item.id)
            if (idx > -1) this.mockData[idx].status = 1
          })
          this.$message.success('审核通过成功！')
          this.$refs.multipleTable.clearSelection()
          this.fetchList()
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消操作' })
        })
    },
    pass(row) {
      this.$confirm('确认通过审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      })
      .then(() => {
        const idx = this.mockData.findIndex(d => d.id === row.id)
        if (idx > -1) this.mockData[idx].status = 1
        this.$message.success('审核通过成功！')
        this.$refs.multipleTable.clearSelection()
        this.fetchList()
      })
      .catch(() => {
        this.$message({ type: 'info', message: '已取消操作' })
      })
    },
    decline(row) {
      this.$prompt('请输入拒绝原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
      .then(({ value }) => {
        const idx = this.mockData.findIndex(d => d.id === row.id)
        if (idx > -1) {
          this.mockData[idx].status = 2
          this.mockData[idx].remark = value
        }
        this.$message.success('拒绝审核成功！')
        this.$refs.multipleTable.clearSelection()
        this.fetchList()
      })
      .catch(() => {
        this.$message({ type: 'info', message: '取消拒绝' })
      })
    },
    // ========== 详情(纯前端) ==========
    openDetail(row) {
      this.detailDialogVisible = true
      this.detailInfo = { ...row }
    },
    handleClose() {
      this.detailDialogVisible = false
      this.detailInfo = {}
    },
    // ========== 删除(纯前端) ==========
    handleDelete(row) {
      this.$confirm(`确认删除团购「${row.title}」?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      .then(() => {
        const idx = this.mockData.findIndex(d => d.id === row.id)
        if (idx > -1) this.mockData.splice(idx, 1)
        this.$message.success('删除成功')
        this.fetchList()
      })
      .catch(() => {
        this.$message({ type: 'info', message: '已取消删除' })
      })
    },
  },
  mounted() {
    this.fetchList()
  },
}
</script>

<style scoped>
.groupbuy {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 120px);
}
.menu-box h2 {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
}
.box-bd {
  margin-top: 20px;
}
.el-pagination {
  margin-top: 20px;
  text-align: right;
}
.groupbuy-form {
  padding: 10px 0;
}
.dialog-footer {
  text-align: center;
}
</style>
